import * as React from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import InformationTooltip from 'modules/core/components/Inputs/InformationTooltip'

import { translate } from 'modules/contracts/lib/translate'

interface Props {
  translations: { [key: string]: string }
}

const BlankSlate = ({ translations }: Props) => {
  return (
    <Box gap="s8">
      <Box flexDirection="row" alignItems="center" gap="s8">
        <Text.Normal color="grey1000" weight="normal" size="200">
          {translate(translations, 'custom_fields')}
        </Text.Normal>
        <InformationTooltip
          information={translate(translations, 'custom_fields_tooltip')}
          icon="question"
        />
      </Box>
      <Box
        paddingY="s16"
        paddingX="s32"
        border={{
          all: {
            width: 's1',
            color: 'grey400',
            style: 'solid',
          },
        }}
        borderRadius={{
          all: 'abs008',
        }}
        flexDirection="row"
        alignItems="center"
      >
        <Text.Normal weight="medium" size="300" color="grey800">
          {translate(translations, 'custom_fields_none')}
        </Text.Normal>
      </Box>
    </Box>
  )
}

export default observer(BlankSlate)
